// src/components/LeftSidebar.jsx
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate }      from "react-router-dom";

import { ReactComponent as LogoIcon }     from "../icons/nav_logo.svg";
import { ReactComponent as ProgressIcon } from "../icons/nav_progress.svg";
import { ReactComponent as CoursesIcon }  from "../icons/nav_courses.svg";
import { ReactComponent as PracticeIcon } from "../icons/nav_practice.svg";
import { ReactComponent as DuelIcon }     from "../icons/nav_battle.svg";
import { ReactComponent as SettingsIcon } from "../icons/nav_settings.svg";
import { ReactComponent as SupportIcon }  from "../icons/nav_support.svg";
import { ReactComponent as LogoutIcon }   from "../icons/nav_exit.svg";

import fetchProtectedData from "../pages/auth/ProtectDataHeader";
import withTokenRefresh    from "../pages/auth/RefreshToken";
import PaymentModal        from "../pages/payment/PaymentModal";
import SubscribeInfoModal  from "../pages/payment/SubscribeInfoModal";
import ComingSoon    from "./ComingSoon";

import "./styles.css";

export default function LeftSidebar() {
  const navigate = useNavigate();

  const [mobileOpen,       setMobileOpen]       = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showInfoModal,    setShowInfoModal]    = useState(false);
  const [showDuelModal,    setShowDuelModal]    = useState(false);
  const [infoText,         setInfoText]         = useState("");

  const [userId,           setUserId]           = useState(null);
  const [subscriptionType, setSubscriptionType] = useState(null);
  const [subscriptionEnd,  setSubscriptionEnd]  = useState(null);

  useEffect(() => {
    const loadUserAndSub = async () => {
      try {
        const user = await withTokenRefresh(fetchProtectedData);
        if (!user) {
          return navigate("/login");
        }
        setUserId(user);

        const res = await fetch(`/api/subscription/?user_id=${user}`, {
          headers: { Accept: "application/json" },
        });
        if (!res.ok) throw new Error(res.statusText);
        const { status, current_period_end } = await res.json();

        setSubscriptionType(status);
        setSubscriptionEnd(
          new Date(current_period_end)
            .toLocaleDateString()
            .replace(/\//g, "-")
        );
      } catch (err) {
        console.error("Sidebar load error:", err);
        navigate("/login");
      }
    };

    loadUserAndSub();
  }, [navigate]);

  const toggleMobile    = () => setMobileOpen(o => !o);
  const handleLogout    = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login");
  };
  const requireSub      = e => {
    if (subscriptionType === "expired") {
      e.preventDefault();
      setInfoText("Купите подписку, чтобы открыть этот раздел");
      setShowInfoModal(true);
    }
  };

  return (
    <>
      {showPaymentModal && (
        <PaymentModal
          onClose={() => setShowPaymentModal(false)}
          subscriptionStatus={subscriptionType}
          subscriptionEndDate={subscriptionEnd}
          user_id={userId}
        />
      )}
      {showInfoModal && (
        <SubscribeInfoModal
          onClose={() => setShowInfoModal(false)}
          subscriptionType={subscriptionType}
          text={infoText}
        />
      )}
      {showDuelModal && (
        <ComingSoon onClose={() => setShowDuelModal(false)} />
      )}

      <header className="mobile-header">
        <button type="button" className="hamburger" onClick={toggleMobile}>
          <span /><span /><span />
        </button>
        <NavLink to="/courses" className="logo">
          <LogoIcon className="logo-icon" />
        </NavLink>
      </header>

      <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
        <NavLink to="/courses" className="logo">
          <div className="logo-pill">
            <LogoIcon className="logo-icon" />
            <span>PAI</span>
          </div>
        </NavLink>

        <nav className="nav-container">
          <ul className="nav-list primary">
            <li className="nav-item-left">
              <NavLink to="/progress" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
                <ProgressIcon className="nav-icon"/><span>Прогресс</span>
              </NavLink>
            </li>
            <li className="nav-item-left">
              <NavLink to="/courses" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
                <CoursesIcon className="nav-icon"/><span>Курсы</span>
              </NavLink>
            </li>
            <li className="nav-item-left">
              <NavLink
                to="/practice_courses"
                onClick={requireSub}
                className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
              >
                <PracticeIcon className="nav-icon"/><span>Практика</span>
              </NavLink>
            </li>
            <li className="nav-item-left">
              <button
                type="button"
                className="nav-link"
                onClick={() => setShowDuelModal(true)}
              >
                <DuelIcon className="nav-icon"/><span>Поединок</span>
              </button>
            </li>
          </ul>

          <ul className="nav-list secondary">
            <li className="nav-item-left">
              <button
                type="button"
                className="nav-link"
                onClick={() => setShowPaymentModal(true)}
              >
                <SettingsIcon className="nav-icon"/><span>Подписка</span>
              </button>
            </li>
            <li className="nav-item-left">
              <button
                type="button"
                className="nav-link"
                onClick={() => {
                  setInfoText(
                    <>
                      Вступайте в наш чат в <br/>
                      <a href="https://t.me/+zuZPicmFhH44OTU6" target="_blank" rel="noopener">
                        телеграм
                      </a>
                    </>
                  );
                  setShowInfoModal(true);
                }}
              >
                <SupportIcon className="nav-icon"/><span>Поддержка</span>
              </button>
            </li>
            <li className="nav-item-left">
              <button
                type="button"
                className="nav-link"
                onClick={handleLogout}
              >
                <LogoutIcon className="nav-icon"/><span>Выйти</span>
              </button>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
}
